import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './AgentFab.module.scss'

export default function AgentFab({ openChat }: { openChat: () => void }) {
  const { t } = useTranslation(['Agent'])
  return (
    <button className={styles.fab} type="button" onClick={openChat}>
      {t('Agent:AI_ASSISTANT')}
    </button>
  )
}
